export default {
  api: {
    bankAccount: {
      bank: {
        notNull: "Selecteer een bank",
      },
      ibanSwift: {
        orRequired: "Voer een IBAN of SWIFT rekeningnummer in",
      },
      iban: {
        invalid: "Ongeldig IBAN nummer",
      },
      currency: {
        notNull: "Geef eerst een standaard valuta op in de systeem instellingen"
      },
      found: "Er bestaat al een bankrekening met deze gegevens"
    },
  },
}
